import { type FC, type ReactNode } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { IconPhone } from '@redteclab/icons'

import { Button, Dialog, DialogContent, DialogTitle } from 'base-ui'

import { type OpenableControls } from '../../generic-hooks'

const description = (chunks: ReactNode[]): ReactNode => (
  <span className="mb-4 block text-m font-normal">{chunks}</span>
)

const smallText = (chunks: ReactNode[]): ReactNode => (
  <span className="block text-s font-normal text-dark-primary-max">
    {chunks}
  </span>
)

export const ContactPageDirectContactSectionTelephoneDialog: FC<{
  modalControls: OpenableControls
}> = ({ modalControls }) => {
  const intl = useIntl()
  const phoneNumber = intl.formatMessage({
    id: 'contactForm.label.hotline.number',
  })

  return (
    <Dialog onClose={modalControls.handleClose} open={modalControls.isOpen}>
      <DialogTitle onClose={modalControls.handleClose}>
        <FormattedMessage id="contact.callUsModal.title" />
      </DialogTitle>
      <DialogContent className="flex h-full flex-col place-content-around gap-2 p-4 text-center">
        <p className="flex flex-col text-xl font-medium tablet:mb-6 tablet:px-48 tablet:py-4">
          <FormattedMessage
            id="contact.directContactSection.phoneDialog"
            values={{
              description,
              hotlineLink: (
                <a
                  className="flex items-center justify-center gap-3 text-dark-brand"
                  href={`tel:${phoneNumber}`}
                >
                  <IconPhone />
                  {phoneNumber}
                </a>
              ),
              smallText,
            }}
          />
        </p>
        <div className="flex w-full flex-col gap-3">
          <Button<'a'>
            className="tablet:hidden"
            href={`tel:${phoneNumber}`}
            slots={{ root: 'a' }}
          >
            <FormattedMessage id="contact.directContactSection.callUs.cta.label" />
          </Button>
          <Button color="secondary" onClick={modalControls.handleClose}>
            <FormattedMessage id="general.button.cancel" />
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
